import { Injectable } from '@angular/core';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { LoggingService } from '../../logging/logic/logging.service';
import { TourStopsService } from '../../tour-stop/logic/tour-stop.service';
import {
  VisibilityRuleService,
  VisibilityRule,
} from '../visibility-rule-service';

@Injectable({
  providedIn: 'root',
})
export class NeedsCashingVisibilityService implements VisibilityRuleService {
  // Public Member
  public readonly name: VisibilityRule = 'needsCashing';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private tourStopService: TourStopsService
  ) {}

  // VisibilityRuleService
  public isVisible(params: any): boolean {
    const tourStopId = this.clientStateService.theState.getValue().tourStopId;

    if (tourStopId == undefined) {
      return false;
    }

    const tourStop = this.tourStopService.getTourStopById(tourStopId);

    if (tourStop == undefined) {
      return false;
    }

    return tourStop.needsCashing;
  }

  // Private Functions
}
